/**
 * スライド検索種別 1:イメージ
 * @type {number}
 */
export const ATTACHMENT_SLIDE_PAGE_TYPE_IMAGE = 1;
/**
 * スライド検索種別 2:カテゴリー
 * @type {number}
 */
export const ATTACHMENT_SLIDE_PAGE_TYPE_CATEGORY = 2;
/**
 * データ種別 1:通常タイプ
 * @type {number}
 */
export const ATTACHMENT_SLIDE_PAGE_DATA_TYPE_NORMAL = 1;
/**
 * データ種別 2:文字多めタイプ
 * @type {number}
 */
export const ATTACHMENT_SLIDE_PAGE_DATA_TYPE_MANY_CHARACTER = 2;
/**
 * データ種別 3:カテゴリ無しタイプ
 * @type {number}
 */
export const ATTACHMENT_SLIDE_PAGE_DATA_TYPE_NO_CATEGORY = 3;
